import { sessionStore } from '@shared/session';

import { clearLegacySession } from './legacy-session';
import type { SessionResponse } from './session.endpoints';

/**
 * 세션 응답(로그인 · 갱신 · 대리 로그인)을 세션 store 에 반영한다.
 * 결과는 store 로만 간다(HTTP client 는 토큰 사본을 갖지 않는다).
 * 새 서버 세션이 생겼으니 구 웹 토큰은 지운다(DD-88 — 로그아웃 뒤 다시 이어받지 않게).
 */
export function applySession(data: SessionResponse): void {
  clearLegacySession();
  sessionStore.getState().authenticate({
    accessToken: data.accessToken,
    identity: {
      userId: data.user.id,
      role: data.user.role,
      roles: data.user.roles,
      ...(data.user.impersonatorId ? { impersonatorId: data.user.impersonatorId } : {}),
      ...(data.user.name ? { name: data.user.name } : {}),
    },
  });
}
